import HomepageButton from '@/legacy-src/components/button/HomepageButton'

import { HeaderHomeBusiness } from './HeaderHomeBusiness'

export interface HeaderHomeProps {
  isBusiness?: boolean
  displayHearme?: boolean
}

export const HeaderHome = ({ isBusiness = false, displayHearme = false }: HeaderHomeProps) => {
  if (isBusiness) {
    return <HeaderHomeBusiness displayHearme={displayHearme} />
  }

  return <HomepageButton className="h-auto w-[6.5rem] max-w-full tablet:w-[10.6875rem]" />
}
